export const coalesce = (...args) => args.find((arg) => arg != null)
